export enum ComponentType {
    EXPIRY = "expiry",
    EXPIRY_MONTH = "expiryMonth",
    EXPIRY_YEAR = "expiryYear",
    NUMBER = "number",
    CVC = "cvc",
    CARD = "card",
}

export type ComponentMeta = {
    empty: boolean,
    error: boolean,
    complete: boolean,
    selection?: {
        start: number,
        end: number
    },
    cardBrand?: string
}